import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Shell({ variant, sidebar, className, ...rest }) {
    return (_jsx("div", { className: cn("fwfa-shell", variant === "workspace" && "fwfa-shell--workspace", className), "data-sidebar": variant === "workspace" ? sidebar : undefined, ...rest }));
}
export function Main({ className, ...rest }) {
    return _jsx("div", { className: cn("fwfa-main", className), ...rest });
}
export function MainBody({ className, ...rest }) {
    return _jsx("div", { className: cn("fwfa-main-body", className), ...rest });
}
export function Container({ className, ...rest }) {
    return _jsx("div", { className: cn("fwfa-container", className), ...rest });
}
//# sourceMappingURL=Shell.js.map